import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

import language from "../../../language";
import { Button } from "../../Button";
import Loading from "../../Loader/Loading";
import { fetchEmergencyOptions } from "../../../utils/queries/emergency";

/**
 * The accountability the doctor accepts before an emergency release form will
 * open at all. Declining creates nothing.
 *
 * The wording is fetched rather than written here: the server stores the exact
 * statement on the request, so the words shown must be the words recorded. A
 * failure to fetch leaves the agree button disabled - better to send the
 * doctor back than to have them accept a statement nobody can produce later.
 */
const EmergencyAccountability = ({ defaultLanguage, onAgree, onDecline }) => {
  const [statement, setStatement] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let live = true;

    fetchEmergencyOptions()
      .then((options) => {
        if (!live) return;

        if (options?.physicianStatement) {
          setStatement(options.physicianStatement);
        } else {
          setFailed(true);
        }

        setIsLoading(false);
      })
      .catch(() => {
        if (!live) return;

        setFailed(true);
        setIsLoading(false);
      });

    return () => {
      live = false;
    };
  }, []);

  return (
    <div>
      <div className="card-body">
        {isLoading && <Loading />}

        {failed && (
          <p className="text-error">
            {language[defaultLanguage].emergency_statement_unavailable}
          </p>
        )}

        {!isLoading &&
          !failed &&
          statement.split("\n\n").map((paragraph, i) => (
            <p key={i} className={i === 0 ? "" : "mt-3"}>
              {paragraph}
            </p>
          ))}
      </div>
      <div className="modal-footer">
        <Button
          text={language[defaultLanguage].emergency_do_not_agree}
          className="btn-default"
          onPress={onDecline}
        />
        <Button
          text={language[defaultLanguage].emergency_agree}
          onPress={() => onAgree(statement)}
          disabled={isLoading || failed}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;

  return { defaultLanguage };
};

export default connect(mapStateToProps)(EmergencyAccountability);
